import React from 'react';

interface SmallConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  message: string;
  closeButtonLabel: string;
  confirmButtonLabel: string;
  isConfirmButtonEnabled?: boolean;
}

const SmallConfirmModal: React.FC<SmallConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  message,
  closeButtonLabel,
  confirmButtonLabel,
  isConfirmButtonEnabled = true,
}) => {
  if (!isOpen) return null;

  // Format the message to handle newlines properly
  const formattedMessage = message.split('\n').map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index < message.split('\n').length - 1 && <br />}
    </React.Fragment>
  ));

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-black bg-opacity-50" onClick={onClose} />
      <div className="relative bg-white border border-yellow-400 text-yellow-700 rounded-lg w-full max-w-md mx-4 z-50">
        <div className="p-6">
          <h3 className="text-lg font-semibold mb-3 text-yellow-800">ต้องการดำเนินการต่อหรือไม่?</h3>
          <div className="text-yellow-700 mb-6 text-base">
            {formattedMessage}
          </div>
          <div className="flex justify-end gap-2 w-full">
            {isConfirmButtonEnabled && <button
              onClick={onConfirm}
              className="px-4 py-2 text-base text-red-700 bg-red-100 rounded-md hover:bg-red-200"
              data-cy="modal-warning-confirm-button"
            >
              {confirmButtonLabel}
            </button>}
            <button
              onClick={onClose}
              className="px-4 py-2 text-base text-white bg-yellow-500 rounded-md hover:bg-yellow-600"
              data-cy="modal-warning-close-button"
            >
              {closeButtonLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmallConfirmModal;